import flocknoteStateHooks from "Flocknote/stateHooks";

import { SIGNUP_ITEM_TABS } from "../EditSignupItemNav/const";
import {
  useAdditionalInfoDisabled,
  useBaseUrl,
  useHasDisabledFundItViaItem,
  useHasFund,
  useRespondentsDisabled,
  useShowRespondentsTab,
  useSlotsTaken,
  useTakePaymentsDisabled,
} from "../EditSignupItemNav/statehooks";

import AdditionalInfo from "./AdditionalInfo";
import FundIt from "./FundIt";
import Info from "./Info";
import Respondents from "./Respondents";

const useTabsConfig = () => {
  const baseUrl = useBaseUrl();
  const showRespondentsTab = useShowRespondentsTab();
  const [{ hasSignupsProfileFields }] =
    flocknoteStateHooks.useNetworkMetadata();
  const hasDisabledFundItViaItem = useHasDisabledFundItViaItem();
  const hasFund = useHasFund();
  const slotsTaken = useSlotsTaken();
  const additionalInfoDisabled = useAdditionalInfoDisabled();
  const takePaymentsDisabled = useTakePaymentsDisabled();
  const respondentsDisabled = useRespondentsDisabled();

  const tabsConfig = [
    {
      key: "info",
      label: "Info",
      icon: "info-circle fas",
      content: Info,
      url: `${baseUrl}${SIGNUP_ITEM_TABS.info}`,
      disabled: false,
    },
  ];

  if (hasSignupsProfileFields)
    tabsConfig.push({
      key: "additional-info",
      label: "Additional Info",
      icon: "info fas",
      content: AdditionalInfo,
      url: `${baseUrl}${SIGNUP_ITEM_TABS.additionalInfo}`,
      disabled: additionalInfoDisabled,
    });

  if (hasFund || hasDisabledFundItViaItem)
    tabsConfig.push({
      key: "fund-it",
      label: "Take Payments",
      icon: "money-bill fas",
      content: FundIt,
      url: `${baseUrl}${SIGNUP_ITEM_TABS.fundIt}`,
      disabled: takePaymentsDisabled,
    });

  if (showRespondentsTab)
    tabsConfig.push({
      key: "respondents",
      label: "Respondents",
      icon: "users fas",
      content: Respondents,
      url: `${baseUrl}${SIGNUP_ITEM_TABS.respondents}`,
      amount: slotsTaken,
      disabled: respondentsDisabled,
    });

  return tabsConfig;
};

export default useTabsConfig;
